<div class="container-fluid mt-3 g-0 px-3">
    <!-- <button class="col-auto" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="getInterventionListFromMockedData()">
        <mat-icon class="material-symbols-outlined">upgrade</mat-icon>
    </button> -->
    <div class="row align-items-center">

        <!-- <button appPreventDoubleClick class="col-auto" color="primary" mat-icon-button (throttledClick)="reset()">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
        </button> -->
        <mat-form-field class="col-6">
            <input matInput i18n-placeholder placeholder="Recherche par nom" [(ngModel)]="SearchText">
        </mat-form-field>
        <div class="col-auto">
            <button appPreventDoubleClick class="w-100 white" color="primary" mat-raised-button (throttledClick)="search()" i18n>
                Rechercher
                <mat-icon class="material-symbols-outlined">search</mat-icon>
            </button>
        </div>

        @if (User?.Type === EUserType.Administrateur || User?.Type === EUserType.Gestionnaire) {
        <div class="col-auto">
            <button appPreventDoubleClick class="w-100 white" color="accent" mat-raised-button (throttledClick)="openCopyConfDialog()" i18n>
                Importer/Copier
                <mat-icon class="material-symbols-outlined">get_app</mat-icon>
            </button>
        </div>
        }
        @if (User?.Type === EUserType.Administrateur || User?.Type === EUserType.Gestionnaire) {
        <div class="col-auto">
            <button appPreventDoubleClick class="white" color="accent" mat-raised-button (throttledClick)="navigateToConf()" i18n>
                Nouvel export
                <mat-icon class="material-symbols-outlined">add</mat-icon>
            </button>
        </div>
        }
    </div>
    <div class="row">
        @for (conf of FilteredConfigList; track conf.Code) {
        <div class="col-12 col-md-6 col-xl-4">
            <div class="h-100 m-3">

                <div class="row border rounded-1 background-light">

                    <div class="col ms-1 p-3">

                        <div class="row">
                            <h2 class="col text-center fw-bold"> {{conf.Name}}
                                @if (conf.IsPublic) {
                                <mat-icon class="material-symbols-outlined align-middle"> public </mat-icon>
                                }
                                @if (!conf.IsPublic) {
                                <mat-icon class="material-symbols-outlined align-middle"> admin_panel_settings </mat-icon>
                                }
                            </h2>
                        </div>

                        <div class="row">
                            <div class="col-6 text-center">

                                <span class="fst-italic">Vos Matrices</span>
                                <div class="row justify-content-center">

                                    <div class="col-auto ">

                                        <mat-chip-listbox>
                                            @for (comp of conf.ProductGroupList; track comp.Code) {
                                            <mat-chip-option class=" mx-1 fw-bold" color="accent" highlighted
                                                             (click)="navigateToLimitConf(conf, comp)">
                                                {{comp.Name}}
                                            </mat-chip-option>
                                            }
                                        </mat-chip-listbox>
                                    </div>
                                </div>
                            </div>

                            <div class="col-6 text-center">
                                <span class="fst-italic">Vos Limites</span>
                                <div class="row align-items-center justify-content-center" cdkDropList cdkDropListOrientation="vertical"
                                     (cdkDropListDropped)="drop($event, conf)">
                                    @for (cat of conf?.LimitCategoryList; track cat.Code) {
                                    <span class="col-12 clickable grabable"
                                          (click)="openCategoryDialog(conf, cat)" cdkDrag>
                                        <span class="badge bg-success my-1 pretty-wrap">{{cat?.Name}} </span>
                                    </span>
                                    }
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2 justify-content-between mt-3 p-1 g-0">

                            <span class="col-auto"></span>
                            <div class="col-auto">

                                @if (User?.Type !== EUserType.Standard) {

                                <button appPreventDoubleClick mat-mini-fab color="error"
                                        class="col-auto text-center mx-1 mat-elevation-z0 white" (throttledClick)="openConfirmDialogToDuplicateMaster(conf)">
                                    <mat-icon class="material-symbols-outlined"> content_copy </mat-icon>
                                </button>
                                }
                                @if (conf.IsMaster) {

                                <button appPreventDoubleClick mat-mini-fab color="primary"
                                        class="col-auto text-center mx-1 mat-elevation-z0" (throttledClick)="openClientDialog(conf)">
                                    <mat-icon class="material-symbols-outlined"> business </mat-icon>
                                </button>
                                }
                                @if (User?.Type === EUserType.Gestionnaire || User?.Type === EUserType.Administrateur) {

                                <button appPreventDoubleClick
                                        mat-mini-fab color="primary" class="col-auto text-center mx-1 mat-elevation-z0" (throttledClick)="openCategoryDialog(conf)">
                                    <mat-icon class="material-symbols-outlined"> category </mat-icon>
                                </button>
                                }

                                <button appPreventDoubleClick mat-mini-fab color="primary" class="col-auto text-center mx-1 mat-elevation-z0"
                                        (throttledClick)="navigateToConf(conf)">
                                    <mat-icon class="material-symbols-outlined"> edit </mat-icon>
                                </button>

                                @if (User?.Type === EUserType.Gestionnaire || User?.Type === EUserType.Administrateur) {

                                <button appPreventDoubleClick
                                        mat-mini-fab color="warn" class="col-auto text-center mx-1" (throttledClick)="checkConfigurationIsDeletable(conf)">
                                    <mat-icon class="material-symbols-outlined"> delete </mat-icon>
                                </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        }
    </div>
</div>